function causa(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Esta doença infecciosa é causada por um vírus denominado SARS-CoV-2. Ele faz parte de uma família viral de RNA conhecida por Coronavírus.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"Em humanos, alguns tipos de coronavírus podem causar doenças respiratórias, que podem variar de infecções leves até mais graves.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"Síndrome Respiratória do Oriente Médio (MERS) e a Síndrome Respiratória Aguda Grave (SARS) são exemplos de infecções graves causadas por um tipo de coronavírus.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"O SARS-CoV-2 tem uma diferença em relação aos coronavírus: o momento em que o vírus mais se multiplica acontece antes mesmo dos infectados apresentarem sintomas da doença.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"Desta forma, os infectados podem transmitir o vírus antes de apresentarem os sintomas da doença, tornando muito maior sua transmissibilidade.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"Portanto, testando positivo para COVID-19, é importante isolar-se mesmo sem apresentar sintomas.",
						"title":"Quem causa a doença?",
						"image":"images/games/informs/causa/1.png",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/causa/1.png"
			}
		]
	};
}

export {causa};
